import React, {
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";

import DialogoAutorizacaoComBiometria2 from '../DialogoAutorizacaoComBiometria2'
import DialogoAutorizacaoComQrcode2 from '../DialogoAutorizacaoComQrcode2'

const DialogoAutorizacao2 = forwardRef(
  (
    {
      handleSalvar,
      title,
      enqueueSnackbar,
      mensagemSucesso = "Item removido com sucesso!",
      openConsultorPrecos = () => {},
      usar_biometria = false,
    },
    ref,
  ) => {

    const refDialogoAutorizacaoComBiometria2 = useRef(null);
    const refDialogoAutorizacaoComQrcode2 = useRef(null);

    useImperativeHandle(ref, () => ({
      handleOpen(codigoNew = 0, dados = null) {
        if(usar_biometria) {
          if(refDialogoAutorizacaoComBiometria2.current) {
            refDialogoAutorizacaoComBiometria2.current.handleOpen(codigoNew, dados, () => {
              if(refDialogoAutorizacaoComQrcode2.current) {
                refDialogoAutorizacaoComQrcode2.current.handleOpen(codigoNew, dados);
              }
            });
          }
        } else {
          if(refDialogoAutorizacaoComQrcode2.current) {
            refDialogoAutorizacaoComQrcode2.current.handleOpen(codigoNew, dados);
          }
        }
      },
    }));

    return (
      <>
        <DialogoAutorizacaoComBiometria2
          ref={refDialogoAutorizacaoComBiometria2}
          handleSalvar={handleSalvar}
          title={title}
          enqueueSnackbar={enqueueSnackbar}
          mensagemSucesso={mensagemSucesso}
          openConsultorPrecos={openConsultorPrecos}
        />

        <DialogoAutorizacaoComQrcode2
          ref={refDialogoAutorizacaoComQrcode2}
          handleSalvar={handleSalvar}
          title={title}
          enqueueSnackbar={enqueueSnackbar}
          mensagemSucesso={mensagemSucesso}
          openConsultorPrecos={openConsultorPrecos}
        />
      </>
    );
  },
);

export default DialogoAutorizacao2;
